import { ModalStore } from '../../../state/ModalStore'
import CoachingCallModal from '../../Modals/CoachingCallModal'
import GradientButton from '../GradientButton'
import NewSecondaryButton from '../NewSecondaryButton'
import WhiteButton from '../WhiteButton'

function BookACallButton({
    children = 'Speak With Our Team',
    scheme = 'default',
    Modal = CoachingCallModal,
    modalProps,
}) {
    const addModal = ModalStore((state) => state.add)

    const handleClick = () => {
        addModal(<Modal {...modalProps} />)
    }

    return scheme === 'white' ? (
        <WhiteButton onClick={handleClick}>{children}</WhiteButton>
    ) : scheme === 'secondary' ? (
        <NewSecondaryButton onClick={handleClick}>
            {children}
        </NewSecondaryButton>
    ) : (
        <GradientButton onClick={handleClick}>{children}</GradientButton>
    )
}

export default BookACallButton
